import { Agent as CommonAgent } from 'modules/Common/Fields'

export const Agent = () => {
  return <CommonAgent data-testid="edit-schedule-agent" />
}
